// Payment choices are frozen when selected; feature flags only govern new choices.
export function decodePaymentMethod(selection, defaultProvider = 'WSPAY') {
  if (!selection) throw new Error('Select a payment method before continuing')
  const parts = selection.split(':')
  if (parts.length === 2) return { provider: parts[0], paymentMethod: parts[1] }

  return { provider: defaultProvider.toUpperCase(), paymentMethod: selection }
}

export function eligiblePaymentMethods(catalog, { keksPay = true, payCek = true } = {}) {
  const methods = (catalog.methods || []).filter(option =>
    (option.method !== 'KeksPay' || keksPay) &&
    (option.method !== 'PayCek' || payCek),
  )

  // Every public checkout uses the same stable provider preference.
  const isRevolutCard = option => option.provider === 'REVOLUT' && option.method === 'CreditCard'

  return [...methods.filter(isRevolutCard), ...methods.filter(option => !isRevolutCard(option))]
}

export function initialPaymentMethod(methods) {
  return methods.length ? methods[0].id : null
}
